import React from "react";
import { useAppSelector } from "../../../../store/hooks";
import ListItem from "./_ListItem";
import ListVertical from "../../../../componets/ListVertical";

const Settings = () => {
  const kinds = useAppSelector(state => state.community.kinds.entities);
  const ids   = useAppSelector(state => state.community.kinds.ids);

  const renderKind = (id: any) => {
    const kind = kinds[id];

    if (!kind) {
      return null;
    }

    return <ListItem key={kind.id} kind={kind} />;
  }

  return (
    <div className='v-kinds-settings'>
      <h6 className="v-content-label o-sm">Settings</h6>

      <ListVertical>
        { ids && ids.map(renderKind) }
      </ListVertical>
    </div>
  )
}

export default Settings;
